module.exports = __webpack_public_path__ + "static/media/lottery-prizes-routes.9a44e3ec.png";